(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
  const overlay = $('[data-overlay]');

  function lock(open) {
    document.body.classList.toggle('no-scroll', open);
    if (overlay) overlay.hidden = !open;
  }
  function show(panel) {
    if (!panel) return;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    lock(true);
  }
  function hide(panel) {
    if (!panel) return;
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    lock(false);
  }

  const searchModal = $('[data-search-modal]');
  const cartDrawer = $('[data-cart-drawer]');
  $$('[data-open-search]').forEach((button) => button.addEventListener('click', () => {
    show(searchModal);
    requestAnimationFrame(() => $('[data-predictive-search-input]', searchModal)?.focus());
  }));
  $('[data-close-search]')?.addEventListener('click', () => hide(searchModal));
  $$('[data-open-cart]').forEach((button) => button.addEventListener('click', async () => {
    await refreshCart();
    show(cartDrawer);
  }));
  $('[data-close-cart]')?.addEventListener('click', () => hide(cartDrawer));
  overlay?.addEventListener('click', () => { hide(searchModal); hide(cartDrawer); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { hide(searchModal); hide(cartDrawer); } });

  const menuButton = $('[data-menu-toggle]');
  menuButton?.addEventListener('click', () => {
    const nav = $('#' + menuButton.getAttribute('aria-controls'));
    const expanded = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!expanded));
    nav?.classList.toggle('is-open', !expanded);
  });

  let searchTimer;
  $('[data-predictive-search-input]')?.addEventListener('input', (event) => {
    clearTimeout(searchTimer);
    const query = event.target.value.trim();
    const results = $('[data-predictive-results]');
    if (!query) { if (results) results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => `<a class="predictive-result" href="${product.url}">${product.image ? `<img src="${product.image}" alt="">` : ''}<span><strong>${product.title}</strong><br>${money(Math.round(Number(product.price) * 100))}</span></a>`).join('') : '<p>No products found.</p>';
      } catch (error) { results.innerHTML = '<p>Press Search to view results.</p>'; }
    }, 250);
  });

  $$('[data-carousel]').forEach((carousel) => {
    const track = $('[data-carousel-track]', carousel);
    const move = (direction) => track?.scrollBy({ left: direction * Math.max(160, track.clientWidth / 3), behavior: 'smooth' });
    $('[data-carousel-prev]', carousel)?.addEventListener('click', () => move(-1));
    $('[data-carousel-next]', carousel)?.addEventListener('click', () => move(1));
    let down = false, startX = 0, startScroll = 0;
    track?.querySelectorAll('img').forEach((image) => { image.draggable = false; });
    track?.addEventListener('dragstart', (event) => event.preventDefault());
    track?.addEventListener('pointerdown', (event) => {
      down = true;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });
    track?.addEventListener('pointermove', (event) => { if (down) track.scrollLeft = startScroll - (event.clientX - startX); });
    track?.addEventListener('pointerup', () => { down = false; track.classList.remove('is-dragging'); });
    track?.addEventListener('pointercancel', () => { down = false; track.classList.remove('is-dragging'); });
  });

  $('[data-sort-collection]')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.assign(url.toString());
  });

  async function refreshCart() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      $$('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.classList.toggle('cart-count--empty', cart.item_count === 0);
      });
      $('[data-cart-drawer-count]') && ($('[data-cart-drawer-count]').textContent = cart.item_count);
      $('[data-cart-drawer-subtotal]') && ($('[data-cart-drawer-subtotal]').textContent = money(cart.total_price));
      const lines = $('[data-cart-drawer-lines]');
      if (lines) lines.innerHTML = cart.items.length ? cart.items.map((item, index) => `<div class="cart-line" data-cart-line><img src="${item.image || ''}" alt=""><div><strong>${item.product_title}</strong><br><small>${item.variant_title || ''}</small><br><label>Quantity <input type="number" min="0" value="${item.quantity}" data-cart-quantity data-line="${index + 1}"></label></div><button class="icon-button" type="button" data-cart-remove data-line="${index + 1}" aria-label="Remove ${item.product_title}">×</button></div>`).join('') : '<p>Your cart is empty</p>';
      return cart;
    } catch (error) { console.error(error); return null; }
  }
  cartDrawer?.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.line), quantity: Number(input.value) }) });
    await refreshCart();
  });
  cartDrawer?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.line), quantity: 0 }) });
    await refreshCart();
  });

  $$('[data-product-root]').forEach((root) => {
    const form = $('form[action*="/cart/add"], form.product-form', root);
    if (!form || form.dataset.equipProductInitialized === 'true') return;
    form.dataset.equipProductInitialized = 'true';
    const variantsNode = $('[data-product-variants]', root);
    if (!form || !variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const variantInput = $('[data-variant-id]', form);
    const quantityInput = $('[data-product-quantity]', form);
    const priceNode = $('[data-product-price]', root);
    const compareNode = $('[data-product-compare]', root);
    const addButton = $('[data-add-to-cart]', form);
    const addLabel = $('[data-add-label]', form);
    const errorNode = $('[data-product-error]', form);
    const flavorBox = $('[data-bundle-flavors]', form);
    let currentVariant = variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
    let bundleQuantity = 1;

    const optionValues = () => $$('[data-product-option]', form).map((fieldset) => $('input:checked', fieldset)?.value);
    const variantForOptions = (values) => variants.find((variant) => variant.options.every((option, index) => option === values[index]));
    const updateVariant = (variant) => {
      if (!variant) { addButton.disabled = true; addLabel.textContent = 'UNAVAILABLE'; return; }
      currentVariant = variant;
      variantInput.value = variant.id;
      priceNode.textContent = money(variant.price);
      if (compareNode) compareNode.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      $$('[data-product-option]', form).forEach((fieldset, index) => { const selected = $('[data-selected-option]', fieldset); if (selected) selected.textContent = variant.options[index]; });
      if (variant.featured_media) $(`[data-gallery-thumb][data-media-id="${variant.featured_media.id}"]`, root)?.click();
    };
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-product-option] input')) updateVariant(variantForOptions(optionValues()));
      if (event.target.matches('input[name="bundle"]')) {
        bundleQuantity = Number(event.target.value);
        quantityInput.value = bundleQuantity;
        $$('.bundle-option', form).forEach((row) => row.classList.toggle('is-selected', row.contains(event.target)));
        renderFlavorSelectors();
        updateVariant(currentVariant);
      }
    });
    function renderFlavorSelectors() {
      if (!flavorBox) return;
      if (bundleQuantity < 2) { flavorBox.innerHTML = ''; flavorBox.classList.remove('is-visible'); return; }
      const firstOptionValues = [...new Set(variants.map((variant) => variant.options[0]))];
      flavorBox.innerHTML = Array.from({ length: bundleQuantity }, (_, index) => `<label>Flavor ${index + 1}<select data-bundle-flavor>${firstOptionValues.map((value) => `<option value="${value}" ${value === currentVariant.options[0] ? 'selected' : ''}>${value}</option>`).join('')}</select></label>`).join('');
      flavorBox.classList.add('is-visible');
    }
    const galleryThumbs = $$('[data-gallery-thumb]', root);
    const galleryDots = $$('[data-gallery-dot]', root);
    let galleryIndex = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const showGalleryImage = (index) => {
      if (!galleryThumbs.length) return;
      galleryIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[galleryIndex];
      const image = $('[data-gallery-main]', root);
      if (image) {
        image.src = thumb.dataset.mediaSrc;
        image.removeAttribute('srcset');
      }
      galleryThumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === galleryIndex));
      galleryDots.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === galleryIndex));
    };
    galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showGalleryImage(index)));
    galleryDots.forEach((dot, index) => dot.addEventListener('click', () => showGalleryImage(index)));
    $('[data-gallery-prev]', root)?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
    $('[data-gallery-next]', root)?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));
    form.addEventListener('submit', async (event) => {
      if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      errorNode.hidden = true; addButton.disabled = true; addLabel.textContent = 'Adding…';
      try {
        let items;
        const flavorSelections = $$('[data-bundle-flavor]', form);
        if (bundleQuantity > 1 && flavorSelections.length) {
          const counts = {};
          flavorSelections.forEach((select) => {
            const options = [...currentVariant.options]; options[0] = select.value;
            const variant = variantForOptions(options) || variants.find((candidate) => candidate.options[0] === select.value && candidate.available);
            if (!variant) throw new Error(`${select.value} is unavailable`);
            counts[variant.id] = (counts[variant.id] || 0) + 1;
          });
          items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));
        } else items = [{ id: Number(currentVariant.id), quantity: 1 }];
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) { const payload = await response.json(); throw new Error(payload.description || 'Unable to add to cart'); }
        await refreshCart(); show(cartDrawer);
      } catch (error) { errorNode.textContent = error.message; errorNode.hidden = false; }
      finally { addButton.disabled = !currentVariant.available; updateVariant(currentVariant); }
    });
    addButton?.addEventListener('click', () => form.requestSubmit());
    $('[data-sticky-submit]', root)?.addEventListener('click', () => form.requestSubmit());
    const sticky = $('[data-sticky-atc]', root);
    if (sticky && addButton) {
      const updateSticky = () => sticky.classList.toggle('is-visible', addButton.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
    }
  });

  document.documentElement.classList.remove('no-js');
})();
